
import { DialogTitle } from "@/components/ui/dialog";
import { useTheme } from "@/lib/theme/ThemeContext";
import { Edit } from "lucide-react";

export function EditChildDialogHeader() {
  const isLightTheme = false;

  return (
    <div className="flex items-center gap-3">
      <div className={`p-2 rounded-full ${
        isLightTheme 
          ? "bg-orange-50 text-orange-500" 
          : "bg-slate-800 text-orange-400"
      }`}>
        <Edit className="h-5 w-5" />
      </div>
      <DialogTitle className={`text-lg font-semibold ${
        isLightTheme ? "text-slate-800" : "text-white"
      }`}>
        Edit Child Information
      </DialogTitle>
    </div>
  );
}
